var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteCharityMemory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2495_7046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.08 6H12.5862C11.2464 6 10.1602 7.08615 10.1602 8.42605V28.3908C10.1602 29.7306 11.2463 30.8168 12.5862 30.8168H28.08C29.4199 30.8168 30.5061 29.7307 30.5061 28.3908V8.42605C30.5061 7.0862 29.4199 6 28.08 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9172 30.8166H12.5855C11.2462 30.8166 10.1602 29.7305 10.1602 28.3913V8.42594C10.1602 7.08609 11.2462 6 12.5855 6H13.9172C12.5773 6 11.4912 7.08609 11.4912 8.42594V28.3913C11.4912 29.7305 12.5773 30.8166 13.9172 30.8166Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.506 16.2764V28.3907C30.506 29.7304 29.4198 30.8166 28.0801 30.8166H12.586C11.2463 30.8166 10.1602 29.7304 10.1602 28.3907V11.0538C10.3196 11.0336 10.4818 11.0234 10.6469 11.0234H18.6514C19.9979 11.0234 21.2469 11.7271 21.9444 12.8787L22.7726 14.2454C23.4706 15.397 24.7191 16.1006 26.0655 16.1006H29.3534C29.7551 16.1006 30.1421 16.162 30.506 16.2764Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.204 21.4135V30.1499C33.204 32.2764 31.4802 34.0003 29.3537 34.0003H10.6473C8.52073 34.0003 6.79688 32.2764 6.79688 30.1499V16.3367C6.79688 14.2102 8.52073 12.4863 10.6473 12.4863H18.6517C19.9983 12.4863 21.247 13.1898 21.9448 14.3414L22.7728 15.708C23.4706 16.8597 24.7193 17.5631 26.0659 17.5631H29.3536C31.4801 17.5631 33.204 19.2869 33.204 21.4135Z",
    fill: "#E63946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6707 34.0002H10.647C8.52084 34.0002 6.79688 32.2762 6.79688 30.15V16.3365C6.79688 14.2097 8.52084 12.4863 10.647 12.4863H12.6707C10.544 12.4863 8.81998 14.2097 8.81998 16.3365V30.15C8.81998 32.2762 10.5439 34.0002 12.6707 34.0002Z",
    fill: "#F25D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1299 24.4126L23.9494 22.5931C24.2564 22.2861 24.2564 21.7883 23.9494 21.4813L22.9318 20.4637C22.6248 20.1566 22.127 20.1566 21.82 20.4637L20.0005 22.2832L18.181 20.4637C17.874 20.1566 17.3762 20.1566 17.0692 20.4637L16.0516 21.4813C15.7445 21.7883 15.7445 22.2861 16.0516 22.5931L17.8711 24.4126L16.0516 26.2321C15.7445 26.5391 15.7445 27.0369 16.0516 27.3439L17.0692 28.3615C17.3762 28.6685 17.874 28.6685 18.181 28.3615L20.0005 26.542L21.82 28.3615C22.127 28.6685 22.6248 28.6685 22.9318 28.3615L23.9494 27.3439C24.2564 27.0369 24.2564 26.5391 23.9494 26.2321L22.1299 24.4126Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2495_7046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCharityMemory);
export default __webpack_public_path__ + "static/media/DeleteCharityMemory.d3b5d0a674375cee4b1af2d6c7066a14.svg";
export { ForwardRef as ReactComponent };